import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../../core/store-actions.interface';
import { CcwPropertyInformationModel } from '../../../closing-cost-worksheet-15/models/ccw-property-information.model';
import { SizeInAcres } from '../../../closing-cost-worksheet-15/models/ccw.enums';

function createInitialState(): CcwPropertyInformationModel {
  return <CcwPropertyInformationModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-ccw-property-store' })
export class CmgCcwPropertyStore extends Store<CcwPropertyInformationModel> implements iStoreActions<CcwPropertyInformationModel> {
  private _initValue: CcwPropertyInformationModel = null;

  constructor() {
    super(createInitialState());
  }

  preInitialize(propertyInfo: CcwPropertyInformationModel): void {
    if (propertyInfo) {
      // Setup default values
      if (!propertyInfo.sizeInAcres) {
        propertyInfo.sizeInAcres = SizeInAcres.ZeroToNine;
      }
    }

    this.update(propertyInfo);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  reset(hardReset: boolean = false): void {
    if (hardReset) {
      super.reset(); // clear out store - called when ClosingCostWorksheetComponent is destroyed
    } else {
      this.update(this._initValue); // revert back to initial values returned from GetCCW endpoint - called when Reset is clicked
    }
  }

  get initialValue() {
    return this._initValue;
  }
}
